




















import Vue from 'vue'
import {fromJson} from "@/components/portfolio/PortfolioProject";
import PortfolioGridItem from "@/components/portfolio/PortfolioGridItem.vue";
import TitleWidget from "@/components/common/TitleWidget.vue";
import stringsKeys from "@/i18n/strings.json";
import projects from '@/data/projects.json';

export default Vue.extend({
  name: "ScreenPortfolio",
  components: {PortfolioGridItem, TitleWidget},
  methods: {
    isWide: (list: any[], index: number): boolean => {
      let length = list.length;
      let a = length % 2;
      let inverseIndex = length - index;
      return a == 1 && inverseIndex == 1;
    },
    isHalf: (list: any[], index: number): boolean => {
      let length = list.length;
      let a = length % 3;
      let inverseIndex = length - index;
      return a == 2 && a >= inverseIndex;
    },
    isSuperWide: (list: any[], index: number): boolean => {
      let length = list.length;
      let a = length % 3;
      let inverseIndex = length - index;
      return a == 1 && a == inverseIndex;
    },
  },
  data: () => {
    return {
      locale: stringsKeys,
      portfolioList: fromJson(projects),
    }
  },
})
